import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CloseLostPetListingComponent } from './close-lost-pet-listing/close-lost-pet-listing.component';
import { MarketingConfirmationComponent } from './marketing-confirmation/marketing-confirmation.component';
import { PerkModalComponent } from './perk/perk-modal.component';
import { PetPassedAwayComponent } from './pet-passed-away/pet-passed-away.component';
import { ArchivePetModalComponent } from './archive-pet-modal/archive-pet-modal.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { PetplanCancelConfirmationModalComponent } from './petplan-cancel-confirmation-modal/petplan-cancel-confirmation-modal.component';
import { PetRehomeModalComponent } from './pet-rehome-modal/pet-rehome-modal.component';
import { FileDownloadModalComponent } from './file-download-modal/file-download-modal.component';
import { PetMissingModalComponent } from './pet-missing-modal/pet-missing-modal.component';
import { BreedSelectorModalComponent } from './breed-selector-modal/breed-selector-modal.component';
import { PetRehomePermissionRequestModalComponent } from './pet-rehome-permission-request-modal/pet-rehome-permission-request-modal.component';
import { ImageUploaderModalComponent } from './image-uploader-modal/image-uploader-modal.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MapSearchModalComponent } from './map-search-modal/map-search-modal.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { UpdateDetailsModalComponent } from './update-details-modal/update-details-modal.component';
import { PetFoundModalComponent } from './pet-found-modal/pet-found-modal.component';
import { PetRehomeSuccessModalComponent } from './pet-rehome-success-modal/pet-rehome-success-modal.component';
import { PetRehomeInProccessModalComponent } from './pet-rehome-in-proccess-modal/pet-rehome-in-proccess-modal.component';
import { AppRoutingModule } from '../app-routing.module';
import { EmailSearchModalComponent } from './email-search-modal/email-search-modal.component';
import { FollowUsModalComponent } from './follow-us-modal/follow-us-modal.component';
import { ChipSearchModalComponent } from './chip-search-modal/chip-search-modal.component';
import { UpgradeSubscriptionModalComponent } from './upgrade-subscription-modal/upgrade-subscription-modal.component';
import { QrCodeLocationModalComponent } from './qr-code-location-modal/qr-code-location-modal.component';
import { TokExploreModalComponent } from './tok-explore-modal/tok-explore-modal.component';
import { TokCompleteModalComponent } from './tok-complete-modal/tok-complete-modal.component';
import { PetplanDeclineInsuranceModalComponent } from './petplan-decline-insurance-modal/petplan-decline-insurance-modal.component';
import { NewsletterModalComponent } from './newsletter-modal/newsletter-modal.component';
import { ImageCropperComponent } from 'ngx-image-cropper';

@NgModule({
  declarations: [
    CloseLostPetListingComponent,
    MarketingConfirmationComponent,
    PerkModalComponent,
    ArchivePetModalComponent,
    LoginModalComponent,
    EmailSearchModalComponent,
    FollowUsModalComponent,
    NewsletterModalComponent,
    UpgradeSubscriptionModalComponent,
    ChipSearchModalComponent,
    PetPassedAwayComponent,
    PetplanCancelConfirmationModalComponent,
    PetplanDeclineInsuranceModalComponent,
    PetRehomeModalComponent,
    FileDownloadModalComponent,
    PetMissingModalComponent,
    BreedSelectorModalComponent,
    PetRehomePermissionRequestModalComponent,
    ImageUploaderModalComponent,
    MapSearchModalComponent,
    ConfirmationModalComponent,
    UpdateDetailsModalComponent,
    PetFoundModalComponent,
    PetRehomeSuccessModalComponent,
    PetRehomeInProccessModalComponent,
    QrCodeLocationModalComponent,
    TokExploreModalComponent,
    TokCompleteModalComponent,
    PetplanDeclineInsuranceModalComponent,
  ],
  imports: [
    SharedModule,
    FileUploadModule,
    AppRoutingModule,
    ImageCropperComponent,
  ],
  exports: [],
})
export class ModalsModule {}
